import { useModal, useRouter } from '@application/utils';
import { Analytics } from '@application/utils/analytics';
import { PartnerModal } from '@presentation/components';
import { MtAdvantagesPage } from '@presentation/pages';
import type { FC } from 'react';
import { useMemo, useState } from 'react';

import type { Advantage, MtAdvantagesPageControllerProps } from './types';
import { IMAGES, QRCODES } from './assets';

export * from './types';

export const MtAdvantagesPageController: FC<MtAdvantagesPageControllerProps> = (props) => {
  const { resource } = props;

  const { translate, language } = useRouter();
  const { modal, show } = useModal();
  const [modalItem, setModalItem] = useState<Advantage>();

  const advantages = useMemo(() => {
    const translations: { [key: string]: any } =
      translate(`mt.advantages.${resource}`, { returnObjects: true }) ?? {};

    return Object.entries(translations).map(([key, value]) => {
      if (!value.name || !value.card.text || !value.card.cta || !value.details.text) {
        throw new Error();
      }

      const QRCode = QRCODES[key]?.[language];

      const whatsappCta = value.details.whatsapp?.url
        ? {
            text: value.details.whatsapp?.text,
            url: value.details.whatsapp.url,
          }
        : null;
      return {
        name: value.name,
        text: value.card.text,
        cta: value.card.cta,
        logo: IMAGES[key],
        onClick: () => {
          setModalItem({
            ...value,
            text: value.details.text,
            moreInfo: value.details.moreInfo,
            QRCode,
            ...(whatsappCta && { whatsappCta }),
          });
          show();
          Analytics.sendOpenRequestCouponModal(value.name);
        },
      } as Advantage;
    });
  }, [language, resource, show, translate]);

  return (
    <>
      <PartnerModal
        modal={modal}
        title={modalItem?.name}
        text={modalItem?.text}
        QRCode={modalItem?.QRCode}
        moreInfo={modalItem?.moreInfo}
        {...(modalItem?.whatsappCta && { whatsappCta: modalItem.whatsappCta })}
      />
      <MtAdvantagesPage items={advantages} />
    </>
  );
};
